module.exports = __webpack_public_path__ + "img/curved-rail-vertical-right-bottom-stone-path.6f80ca52.png";